"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateRBACAppConfig = function (user) {
  var config = {};
  var features = user.features,
    gates = user.gates;
  var orgHasConvoAnalysis = !!gates.has_insights;
  var userHasConvoAnalysis = utils_1.hasFeature(features, {
    featureName: "conversation_analysis",
    accessLevel: "READ"
  });
  // check access to insights application
  config = ramda_1.set(ramda_1.lensProp('hasInsights'), orgHasConvoAnalysis && userHasConvoAnalysis, config);
  // check access to saved searches
  config = ramda_1.set(ramda_1.lensProp('hasSavedSearches'), !!gates.has_saved_searches, config);
  // allow for 1 year on the datepicker
  config = ramda_1.set(ramda_1.lensProp('hasYearHistory'), !!gates.premium_enterprise || !!gates.enterprise_04_2018, config);
  // check access to beta currently used for automated tasks
  config = ramda_1.set(ramda_1.lensProp('insightsBeta'), !!gates.insights_beta, config);
  // check access to beta features
  config = ramda_1.set(ramda_1.lensProp('insightsFeatureBeta'), !!gates.insights_feature_beta, config);
  // check access to cluster insights features
  config = ramda_1.set(ramda_1.lensProp('hasClusterInsights'), !!gates.has_cluster_insights, config);
  // check access to cluster insights features
  config = ramda_1.set(ramda_1.lensProp('hasConvoAlerts'), !!gates.has_convo_alerts, config);
  return config;
};
exports["default"] = generateRBACAppConfig;